// School context helper for multi-tenancy support

/// <reference lib="dom" />

/**
 * Get the current school context from authStore
 * Returns null for Super Admin users or when no context is set
 */
export function getSchoolContext(): string | null {
  if (typeof window === 'undefined') return null
  
  try {
    const authStorage = window.sessionStorage.getItem('auth-storage')
    if (!authStorage) return null
    
    const authData = JSON.parse(authStorage)
    const state = authData?.state
    
    if (!state) return null
    
    // Super Admin users have null school_id
    if (state.user?.role === 'super_admin') {
      // Return schoolContext if set (Super Admin viewing specific school)
      return state.schoolContext || null
    }
    
    // Regular users use their school_id
    return state.user?.school_id || null
  } catch {
    return null
  }
}

/**
 * Check if the current user is a Super Admin
 */
export function isSuperAdmin(): boolean {
  if (typeof window === 'undefined') return false
  
  try {
    const authStorage = window.sessionStorage.getItem('auth-storage')
    if (!authStorage) return false
    
    const authData = JSON.parse(authStorage)
    const state = authData?.state
    
    return state?.user?.role === 'super_admin'
  } catch {
    return false
  }
}
